"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Keycloak
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse401ToJSON = exports.InlineResponse401FromJSONTyped = exports.InlineResponse401FromJSON = void 0;
function InlineResponse401FromJSON(json) {
    return InlineResponse401FromJSONTyped(json, false);
}
exports.InlineResponse401FromJSON = InlineResponse401FromJSON;
function InlineResponse401FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'message': json['message'],
    };
}
exports.InlineResponse401FromJSONTyped = InlineResponse401FromJSONTyped;
function InlineResponse401ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'message': value.message,
    };
}
exports.InlineResponse401ToJSON = InlineResponse401ToJSON;
//# sourceMappingURL=InlineResponse401.js.map